import React, { useEffect, useState } from "react";
import styles from "./overview.module.css";
import StatisticsCard from "../../../../../components/statistics-card/statistics-card";
import { getStudentStatAttendance } from "../../../../../services/student";

const OverviewStudentAttendance = ({ selectedDate }) => {
  const [overviewStatistics, setOverviewStatistics] = useState({});
  const [loading, setLoading] = useState(false);
  const fetchStudentAttendanceStat = async () => {
    try {
      setLoading(true);
      const params = { date: selectedDate };
      const response = await getStudentStatAttendance(params);
      if (response?.data) {
        const data = response?.data?.data;
        setOverviewStatistics(data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudentAttendanceStat();
  }, [selectedDate]);

  const overview_statistics = [
    {
      icon_name: "graduation-hat-icon",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Total Student Present For Today",
      card_bg_color: " rgba(233, 243, 255, 1)",
      icon_container_bg_color: "rgba(86, 155, 246, 1)",
      statistic_value: overviewStatistics?.presentCount ?? "0",
    },

    {
      icon_name: "clipboard",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Total Student Absent For Today",
      card_bg_color: "rgba(231, 248, 255, 1)",
      icon_container_bg_color: "rgba(75, 202, 255, 1)",
      statistic_value: overviewStatistics?.absentCount ?? "0",
    },

    {
      icon_name: "total-parent-icon",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Incomplete Class Attendance Markings",
      card_bg_color: "rgba(255, 249, 226, 1)",
      icon_container_bg_color: " rgba(223, 195, 86, 1)",
      statistic_value: overviewStatistics?.unmarkedCount ?? "0",
    },
    {
      icon_name: "total-room-icon",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Total Week Attendance",
      card_bg_color: "rgba(231, 248, 255, 1)",
      icon_container_bg_color: "rgba(75, 202, 255, 1)",
      statistic_value: overviewStatistics?.weeklyAttendance ?? "0",
    },
    {
      icon_name: "book-closed",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Total Month Attendance",
      card_bg_color: "rgba(242, 255, 244, 1)",
      icon_container_bg_color: "rgba(41, 194, 65, 1)",
      statistic_value: overviewStatistics?.monthlyAttendance ?? "0",
    },

    {
      icon_name: "users-icon",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Total Term Attendance",
      card_bg_color: "rgba(255, 243, 238, 1)",
      icon_container_bg_color: "rgba(224, 90, 33, 1)",
      statistic_value: overviewStatistics?.termAttendance ?? "0",
    },
  ];

  return (
    <div className={styles.statistics_overview}>
      <div className={styles.statistics}>
        {overview_statistics?.map(
          ({
            icon_name,
            icon_fill,
            icon_stroke,
            icon_width,
            icon_height,
            heading_text,
            card_bg_color,
            icon_container_bg_color,
            statistic_value,
          }) => (
            <div className={styles.statistics_card}>
              <StatisticsCard
                icon_name={icon_name}
                icon_fill={icon_fill}
                icon_stroke={icon_stroke}
                icon_width={icon_width}
                icon_height={icon_height}
                heading_text={heading_text}
                card_bg_color={card_bg_color}
                icon_container_bg_color={icon_container_bg_color}
                statistic_value={statistic_value}
                loading={loading}
              />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default OverviewStudentAttendance;
